import {
  Datasource,
  DatasourceType,
  ConnectionStatus,
} from '@/services/datasources/types'

export const mockDatasources: Datasource[] = [
  {
    id: 'ds_001',
    name: 'KambaData Demo Snowflake',
    type: DatasourceType.SNOWFLAKE,
    description:
      'Demo Snowflake instance with sample financial datasets for testing and development',
    provider: 'KambaData',
    connectionStatus: ConnectionStatus.CONNECTED,
    lastConnected: new Date(Date.now() - 300000).toISOString(), // 5 minutes ago
    createdAt: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString(), // 90 days ago
    updatedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    config: {
      host: 'kamba-demo.snowflakecomputing.com',
      database: 'DEMO_FINANCIAL_DATA',
      username: 'demo_user',
      region: 'us-east-1',
      warehouse: 'DEMO_WH',
    },
    metadata: {
      dataFrequency: 'Daily updates',
      dataFormat: 'Structured Tables',
      dataVolume: '~500GB',
      latency: '~1-3 seconds',
      reliability: '99.9%',
    },
    tags: ['demo', 'snowflake', 'financial', 'sample-data'],
    usageStats: {
      totalQueries: 15248,
      lastQueried: new Date(Date.now() - 120000).toISOString(),
      avgResponseTime: 1850,
      errorRate: 0.02,
    },
  },
  {
    id: 'ds_002',
    name: 'EDGAR API',
    type: DatasourceType.API,
    description:
      'SEC EDGAR database API for accessing company filings, financial statements, and regulatory documents',
    provider: 'SEC',
    connectionStatus: ConnectionStatus.CONNECTED,
    lastConnected: new Date(Date.now() - 600000).toISOString(),
    createdAt: new Date(Date.now() - 180 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    config: {
      endpoint: 'https://data.sec.gov/api/',
      apiKey: '****-****-****-edgar',
      rateLimit: '10 requests/second',
      dataFormat: 'JSON/XML',
    },
    metadata: {
      dataFrequency: 'Real-time filings',
      dataFormat: 'JSON/XML',
      dataVolume: '~10GB/day',
      latency: '<500ms',
      reliability: '99.5%',
    },
    tags: ['sec', 'edgar', 'filings', 'regulatory'],
    productId: 'prod_edgar_001',
    productName: 'EDGAR Filings API',
    usageStats: {
      totalQueries: 45823,
      lastQueried: new Date(Date.now() - 1800000).toISOString(),
      avgResponseTime: 340,
      errorRate: 0.08,
    },
  },
  {
    id: 'ds_003',
    name: 'Brain Sentiment Analysis Product',
    type: DatasourceType.PRODUCT_CATALOG,
    description:
      'AI-powered sentiment analysis for financial news, social media, and analyst reports',
    provider: 'Brain Company',
    connectionStatus: ConnectionStatus.CONNECTED,
    lastConnected: new Date(Date.now() - 180000).toISOString(),
    createdAt: new Date(Date.now() - 120 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 3600000).toISOString(),
    config: {
      endpoint: 'https://api.brain-company.com/v2/sentiment',
      apiKey: '****-****-****-brain',
      model: 'financial-sentiment-v3',
      languages: ['en', 'es', 'zh'],
    },
    metadata: {
      dataFrequency: 'Real-time',
      dataFormat: 'JSON',
      dataVolume: '~5GB/day',
      latency: '<100ms',
      reliability: '99.95%',
    },
    tags: ['sentiment', 'nlp', 'news', 'social-media', 'ai'],
    productId: 'prod_brain_001',
    productName: 'Brain Financial Sentiment Pro',
    usageStats: {
      totalQueries: 892456,
      lastQueried: new Date(Date.now() - 60000).toISOString(),
      avgResponseTime: 85,
      errorRate: 0.05,
    },
  },
]
